import { Observable } from 'rxjs'
import { BeneficiarySoaEmailDetail } from '../models/soa-view-email-model'

export abstract class SOAFormReturnAgentGateWay {
    abstract returnToAgent(searchsoadetail: BeneficiarySoaEmailDetail): Observable<boolean>
    abstract GetSOADetailsOnUniqueLink(uniqueLink: String): Observable<BeneficiarySoaEmailDetail>
}
